import useSite from "@casino/legacy/client/hooks/useSite";
import { useTelegramQuery } from "@workspace/casino_core/queries/TelegramQuery.client";
import { setCookie } from "@workspace/cookies/browser";
import { useCallback } from "react";
import type DataAuthType from "../@types/DataAuthType";
import useTelegramAPI from "./useTelegramAPI";
import useTelegramAuth from "./useTelegramAuth";

type Args = { code?: string; otp?: string; setOtpError?: () => void };

const useTelegramConnection = () => {
  const { site, isSportsbet, siteConfig } = useSite();
  const { telegramAPI } = useTelegramAPI();
  const variables = {
    site,
    name: isSportsbet ? "socialLoginTelegram" : "TelegramLogin",
  };
  const { loading, error, data } = useTelegramQuery({
    variables,
  });
  const { handleTelegramAuth } = useTelegramAuth();

  const handleTelegramConnect = useCallback(
    ({ setOtpError, otp }: Args) => {
      const domain = global.location.host;
      const botId = telegramAPI?.[domain] || telegramAPI?.[siteConfig.domain];

      if (!botId) {
        return;
      }

      setCookie("social_auth_type", "telegram");
      global?.Telegram?.Login.auth(
        {
          bot_id: botId,
          request_access: true,
        },
        (dataAuth: DataAuthType) => {
          handleTelegramAuth({ dataAuth, setOtpError, otp });
        },
      );
    },
    [telegramAPI, siteConfig.domain, handleTelegramAuth],
  );

  return { loading, error, data, handleTelegramConnect };
};

export default useTelegramConnection;
